import { useEffect } from 'react';
export const useOnClickOutside = ({ behavior, referenceElement, popperElement, setOpen, }) => {
    useEffect(() => {
        if (behavior === 'click') {
            document.addEventListener('click', (event) => {
                if (referenceElement.current && referenceElement.current.contains(event.target))
                    return;
                if (popperElement.current && popperElement.current.contains(event.target))
                    return;
                setOpen(false);
            });
        }
        return () => {
            document.removeEventListener('click', () => setOpen(false));
        };
    }, [referenceElement, referenceElement, popperElement]);
};
